angular.module('app', [
    'ngMask', 'localytics.directives', 'monospaced.elastic', 'vcRecaptcha', 'datetimepicker', 'angular.filter'
]).config(function ($interpolateProvider) {
    $interpolateProvider.startSymbol('<%').endSymbol('%>');
}).config(['$locationProvider', function ($locationProvider) {
    $locationProvider.hashPrefix('');
}]).config(['$qProvider', function ($qProvider) {
    $qProvider.errorOnUnhandledRejections(false);
}]);